import {Role} from '../app/enum/role'
export const PATH_CONFIG = [
    {
        label: 'Mensajeria',
        path: './estadistica/',
        allowedRoles: [Role.ADMIN],
        options: [
          {
            label: 'Modulo Sigma',
            allowedRoles: [Role.ADMIN],
            path: './estadistica/sendNotification'
          },
          {
            label: 'Listas de contactos',
            allowedRoles: [Role.ADMIN],
            path: './estadistica/listContact',
            options:[]
          }
        ]
      },
      {
        label: 'Novedades',
        path: './almacen/',
        allowedRoles: [Role.ADMIN],
        options: [
          {
            label: 'Horarios Almacenes',
            allowedRoles: [Role.ADMIN],
            path: './almacen/'
          }
        ]
      },
      {
        label: 'Facturas',
        allowedRoles: [Role.CLIENTE,Role.ADMIN],
        path: './facturas/',
        options:[
          {
            label: 'Reigstro Ocr',
            allowedRoles: [Role.CLIENTE,Role.ADMIN],
            path: './facturas/register'
          },
          {
            label:'Facturas Pendientes',
            allowedRoles: [Role.ADMIN],
            path:'./facturas/getBillsPending'
          },
          {
            label:'Facturas Ocr',
            allowedRoles: [Role.ADMIN],
            path:'./facturas/getBills'
          }
        ]
      },
      {
        label: 'FPQRS',
        allowedRoles: [Role.CLIENTE],
        path: './fpqrs/',
        options:[
          {
            label:'Registro FPQRS',
            allowedRoles: [Role.CLIENTE],
            path: './fpqrs/'
          }
        ]
      },
      {
        label: 'Cliente',
        allowedRoles: [Role.ADMIN],
        path: './client/',
        options:[
          {
            label:'Buscar Clientes',
            allowedRoles: [Role.ADMIN],
            path: './client/listClient'
          }
        ]
      },
      {
        label:'Comercial',
        allowedRoles: [Role.ADMIN],
        path: './comercial/',
        options:[
          {
            label:'Buscar Stands',
            allowedRoles: [Role.ADMIN],
            path: './comercial/stand'
          }
        ]
      },
      {
        label:'Admin',
        allowedRoles: [Role.ADMIN],
        path: './admin/',
        options:[
          {
            label:'Plantillas',
            allowedRoles: [Role.ADMIN],
            path: './admin/plantillas'
          }
        ]
      }
]